export default "/_next/static/images/95efdab792bca89b2058bb2b709a622d.jpg";